export const QueueManagementConstants = {
    READ: 'read',
    WRITE: 'write',
    DESK: 'desk',
    DEFAULT_TEAM_NAME: 'Default',
    DEFAULT_OPERATOR: 'Or',
    EXTRAS: 'Extras',
    CONTACT_EXTRAS: 'Contact.Extras',
    PRIORIRY_URGENCY: 1000,
    URL: {
        ATTENDANCE_QUEUES: '/attendance-queues',
        ATTENDANCE_QUEUES_QUEUE: '/attendance-queues/queue/',
        RULES: '/rules',
        RULES_QUEUE: '/rules/queue/',
        PRIORITIES: '/priority-rules',
        PRIORITIES_QUEUE: '/priority-rules/queue/',
    },
    DESTINATION: {
        DESK: 'postmaster@desk.',
    },
    STATES: {
        ADDING: 'ADDING',
        EDITING: 'EDITING',
        VIEWING: 'VIEWING',
    },
};
export const QueuesTracks = {
    PAGE_OPENED: 'helpdesk-queuemanagement-queue-opened ',
    PAGE_ATTENDANT_OPENED: 'helpdesk-queuemanagement-queue-attendant-opened ',
    QUEUE_ATTENDANT_SEARCHED: 'helpdesk-queuemanagement-queue-attendant-searched ',
    QUEUE_ADDED: 'helpdesk-queuemanagement-queue-added ',
    QUEUE_SAVED: 'helpdesk-queuemanagement-queue-saved ',
    QUEUE_DELETED: 'helpdesk-queuemanagement-queue-deleted ',
    QUEUE_ENABLED: 'helpdesk-queuemanagement-queue-enabled ',
    QUEUES_SEARCHED: 'helpdesk-queuemanagement-queue-searched ',
    QUEUE_ATTENDANTS_SEARCHED: 'helpdesk-queuemanagement-queue-attendants-searched ',
    CLEAR_SEARCH: 'helpdesk-queuemanagement-queue-clear-search ',
    ATTENDANT_CLEAR_SEARCH: 'helpdesk-queuemanagement-queue-attendant-clear-search ',
    ADD_QUEUE_CLICKED: 'helpdesk-queuemanagement-queue-add-queue-clicked',
    SOURCE: {
        PORTAL: 'portal',
        BUILDER: 'builder',
    },
    QUEUE_ATTENDANTS_ASSIGN: 'helpdesk-queuemanagement-queue-attendants-assign-clicked ',
    QUEUE_ATTENDANTS_ASSIGN_CONFIRM: 'helpdesk-queuemanagement-queue-attendants-assign-confirm-clicked ',
    QUEUE_ATTENDANTS_UNASSIGN: 'helpdesk-queuemanagement-queue-attendants-unassign-clicked ',
    QUEUE_ATTENDANTS_UNASSIGN_ALL: 'helpdesk-queuemanagement-queue-attendants-unassign-all-clicked ',
    QUEUE_ATTENDANTS_UNASSIGN_CANCEL: 'helpdesk-queuemanagement-queue-attendants-unassign-cancel-clicked ',
    QUEUE_ATTENDANTS_UNASSIGN_CONFIRM: 'helpdesk-queuemanagement-queue-attendants-unassign-confirm-clicked ',
};
